export const Outline = Object.freeze({
	DOUBLE_GIS: 'o-double-gis',
	THREE_PERSONS: 'o-three-persons',
	A_LETTER: 'o-a-letter',
	ACHIEVEMENT: 'o-achievement',
	ACTIVITY: 'o-activity',
	ADD_CHAT: 'o-add-chat',
	ADD_EVENT: 'o-add-event',
	ADD_FUNNEL: 'o-add-funnel',
	ADD_PERSON: 'o-add-person',
	ADD_PRODUCT: 'o-add-product',
	ADD_TIMELINE: 'o-add-timeline',
	AI_STARS_QUESTION: 'o-ai-stars-question',
	AI_STARS: 'o-ai-stars',
	ALARM: 'o-alarm',
	ALERT_ACCENT: 'o-alert-accent',
	ALERT: 'o-alert',
	ALIGN_CENTER: 'o-align-center',
	ALIGN_JUSTIFY: 'o-align-justify',
	ALIGN_LEFT: 'o-align-left',
	ALIGN_RIGHT: 'o-align-right',
	APPS: 'o-apps',
	ATTACH_2: 'o-attach-2',
	ATTACH: 'o-attach',
	AUTOFILL: 'o-autofill',
	BACK_10: 'o-back-10',
	BACK_15: 'o-back-15',
	BARCODE: 'o-barcode',
	BATTERY_1_STICK: 'o-battery-1-stick',
	BATTERY_2_STICKS: 'o-battery-2-sticks',
	BATTERY_NO_CHARGE: 'o-battery-no-charge',
	BLUETOOTH: 'o-bluetooth',
	BOARD: 'o-board',
	BOLD: 'o-bold',
	BOOKMARK_2: 'o-bookmark-2',
	BOOKMARK: 'o-bookmark',
	BOTTLENECK: 'o-bottleneck',
	BOTTOM_MENU: 'o-bottom-menu',
	BOX_WITH_LID: 'o-box-with-lid',
	BOX: 'o-box',
	BUG: 'o-bug',
	BULLETED_LIST: 'o-bulleted-list',
	BUSINES_PROCESS_STAGES: 'o-busines-process-stages',
	BUSINESS_PROCESS_PROGRESS: 'o-business-process-progress',
	BUSINESS_PROCESS: 'o-business-process',
	CALENDAR_EMPTY: 'o-calendar-empty',
	CALENDAR_SHARE: 'o-calendar-share',
	CALENDAR_WITH_CHECKS: 'o-calendar-with-checks',
	CALENDAR_WITH_SLOTS: 'o-calendar-with-slots',
	CALENDAR: 'o-calendar',
	CAMERA_OFF: 'o-camera-off',
	CAMERA: 'o-camera',
	CARD: 'o-card',
	CASH_TERMINAL: 'o-cash-terminal',
	CHANGE_FUNNEL: 'o-change-funnel',
	CHANGE_ORDER_2: 'o-change-order-2',
	CHANGE_ORDER: 'o-change-order',
	CHAT_LIST: 'o-chat-list',
	CHATS: 'o-chats',
	CHECK_LIST: 'o-check-list',
	CIRCLE_CHECK: 'o-circle-check',
	CIRCLE_CROSS: 'o-circle-cross',
	CIRCLE_MINUS: 'o-circle-minus',
	CIRCLE_MORE: 'o-circle-more',
	CIRCLE_PLUS: 'o-circle-plus',
	CLOCK_BACK: 'o-clock-back',
	CLOCK: 'o-clock',
	CLOSE_CHAT: 'o-close-chat',
	CLOUD_DOWNLOAD: 'o-cloud-download',
	CLOUD_SYNC: 'o-cloud-sync',
	CLOUD_TIME: 'o-cloud-time',
	CLOUD_WITH_CHECK: 'o-cloud-with-check',
	CLOUD: 'o-cloud',
	COLLAB: 'o-collab',
	COLLABORATION: 'o-collaboration',
	COLUMNS_SIDEBAR_PENDING: 'o-columns-sidebar-pending',
	COLUMNS: 'o-columns',
	COMPANY: 'o-company',
	COMPLETE_TASK_LIST: 'o-complete-task-list',
	CONTACT: 'o-contact',
	COPILOT: 'o-copilot',
	COPY: 'o-copy',
	CREATE_CHAT: 'o-create-chat',
	CREATE_FILE: 'o-create-file',
	CRM_LETTERS: 'o-crm-letters',
	CRM: 'o-crm',
	CROSSED_EYE: 'o-crossed-eye',
	CROWN: 'o-crown',
	CURSOR_CLICK: 'o-cursor-click',
	CURSORS_STRIKE: 'o-cursors-strike',
	DAY_OFF: 'o-day-off',
	DELAY: 'o-delay',
	DELEGATE: 'o-delegate',
	DELIVERY: 'o-delivery',
	DEMONSTRATION_ON: 'o-demonstration-on',
	DEPARTMENT: 'o-department',
	DESIGN: 'o-design',
	DEVELOPER_RESOURCES: 'o-developer-resources',
	DEVICE_ROTATE: 'o-device-rotate',
	DISK_SHARED: 'o-disk-shared',
	DISLIKE: 'o-dislike',
	DISTRIBUTION: 'o-distribution',
	DOCUMENT_UPDATE: 'o-document-update',
	DOUBLE_CHECK: 'o-double-check',
	DOWNLOAD: 'o-download',
	DUPLICATE: 'o-duplicate',
	EARTH_WITH_CHECK: 'o-earth-with-check',
	EARTH_WITH_CLOCK: 'o-earth-with-clock',
	EARTH_WITH_CROSS: 'o-earth-with-cross',
	EARTH_WITH_STOP: 'o-earth-with-stop',
	EARTH_WITH_TREE: 'o-earth-with-tree',
	EARTH: 'o-earth',
	EMPTY_BATTERY: 'o-empty-battery',
	EMPTY_MESSAGE: 'o-empty-message',
	ENTERPRISE: 'o-enterprise',
	EXPERT_MODE: 'o-expert-mode',
	FAVORITE: 'o-favorite',
	FEEDBACK: 'o-feedback',
	FILE_WITH_CHECK_2: 'o-file-with-check-2',
	FILE_WITH_CHECK: 'o-file-with-check',
	FILE_WITH_CLOCK: 'o-file-with-clock',
	FILE: 'o-file',
	FILTER_2_LINES: 'o-filter-2-lines',
	FILTER_FUNNEL: 'o-filter-funnel',
	FILTER: 'o-filter',
	FIND_FILTERS: 'o-find-filters',
	FIRE: 'o-fire',
	FIRE_SOLID: 'o-fire-solid',
	FLAG_WITH_CROSS: 'o-flag-with-cross',
	FLAG: 'o-flag',
	FOLDER_24: 'o-folder-24',
	FOLDER_PLUS: 'o-folder-plus',
	FOLDER_SUCCESS: 'o-folder-success',
	FOLDER_WITH_CARD: 'o-folder-with-card',
	FOLDER: 'o-folder',
	FORM: 'o-form',
	FORWARD_10: 'o-forward-10',
	FORWARD_15: 'o-forward-15',
	FORWARD: 'o-forward',
	FREELANCE: 'o-freelance',
	FULL_BATTERY: 'o-full-battery',
	GIFT: 'o-gift',
	GLASSES: 'o-glasses',
	GLOBE_EXTRANET: 'o-globe-extranet',
	GO_TO_MESSAGE: 'o-go-to-message',
	GOOGLE_MAPS: 'o-google-maps',
	GRADUATION_CAP: 'o-graduation-cap',
	GRAPHS_DIAGRAM: 'o-graphs-diagram',
	GROUP: 'o-group',
	HAMBURGER_MENU: 'o-hamburger-menu',
	HANDSHAKE: 'o-handshake',
	HEADSET: 'o-headset',
	HEART: 'o-heart',
	HIGH_TEMPERATURE: 'o-high-temperature',
	HOME_STAR: 'o-home-star',
	HOME: 'o-home',
	HOURGLASS: 'o-hourglass',
	IDEA_LAMP: 'o-idea-lamp',
	IMAGE: 'o-image',
	INFO_CIRCLE: 'o-info-circle',
	INTERVAL: 'o-interval',
	INTRANET: 'o-intranet',
	INVENTORY_MANAGEMENT: 'o-inventory-management',
	INVOICE: 'o-invoice',
	ISSUE_INVOICE: 'o-issue-invoice',
	ITALIC: 'o-italic',
	KANBAN: 'o-kanban',
	KEY: 'o-key',
	KNOWLEDGE_BASE: 'o-knowledge-base',
	LAYERS: 'o-layers',
	LEAD: 'o-lead',
	LEFT_RIGHT: 'o-left-right',
	LIKE: 'o-like',
	LINK_SETTINGS: 'o-link-settings',
	LINK: 'o-link',
	LINKS_LIST: 'o-links-list',
	LOCATION_TIME: 'o-location-time',
	LOCATION: 'o-location',
	LOG_IN: 'o-log-in',
	LOG_OUT: 'o-log-out',
	LOWER_RIGHT_ARROW: 'o-lower-right-arrow',
	MAGIC_WAND: 'o-magic-wand',
	MAIL_COUNTER: 'o-mail-counter',
	MAIL_FORWARD: 'o-mail-forward',
	MAIL_IN_PROGRESS: 'o-mail-in-progress',
	MAIL_OPEN: 'o-mail-open',
	MAIL_RETURN: 'o-mail-return',
	MAIL_SEND: 'o-mail-send',
	MAIL: 'o-mail',
	MAIN_TOOL: 'o-main-tool',
	MAP: 'o-map',
	MARKET: 'o-market',
	MAXIMIZE: 'o-maximize',
	MAXIMIZE_2: 'o-maximize-2',
	MAX: 'o-max',
	MEETING_POINT: 'o-meeting-point',
	MENTION: 'o-mention',
	MESSAGE: 'o-message',
	MESSAGES: 'o-messages',
	MESSENGER_META: 'o-messenger-meta',
	MESSENGER: 'o-messenger',
	MICROPHONE_OFF: 'o-microphone-off',
	MICROPHONE_ON: 'o-microphone-on',
	MINIMIZE: 'o-minimize',
	MINIMIZE_2: 'o-minimize-2',
	MOBILE_CONSTRUCTOR: 'o-mobile-constructor',
	MOBILE_SERVICE: 'o-mobile-service',
	MOBILE_STARS: 'o-mobile-stars',
	MOBILE: 'o-mobile',
	MODERATOR: 'o-moderator',
	MONEY: 'o-money',
	MOON: 'o-moon',
	MOVE_TO_CHECKLIST: 'o-move-to-checklist',
	MOVE_TO: 'o-move-to',
	MULTICHOICE_OFF: 'o-multichoice-off',
	MULTICHOICE_ON: 'o-multichoice-on',
	MUSIC: 'o-music',
	MY_DEALS: 'o-my-deals',
	MY_PLAN: 'o-my-plan',
	NEUTRAL: 'o-neutral',
	NEW_MESSAGE: 'o-new-message',
	NEWSFEED: 'o-newsfeed',
	NEXT: 'o-next',
	NO_WIFI: 'o-no-wifi',
	NON_FAVORITE: 'o-non-favorite',
	NOTE: 'o-note',
	NOTIFICATION_OFF: 'o-notification-off',
	NOTIFICATION_SETTINGS: 'o-notification-settings',
	NOTIFICATION_WITH_CROSS: 'o-notification-with-cross',
	NOTIFICATION: 'o-notification',
	NUMBERED_LIST: 'o-numbered-list',
	OBSERVER: 'o-observer',
	ONLINE_BOOKING: 'o-online-booking',
	OPEN_CHANNELS: 'o-open-channels',
	OPEN_CHANNELS_CROSS: 'o-open-channels-cross',
	OPEN_CHAT: 'o-open-chat',
	CHATS_WITH_CHECK: 'o-chats-with-check',
	REPLY: 'o-reply',
	PACKAGE: 'o-package',
	PALETTE: 'o-palette',
	PARTNER_NFC: 'o-partner-nfc',
	PATH: 'o-path',
	PAYMENT_TERMINAL: 'o-payment-terminal',
	PAYMENT: 'o-payment',
	PERSON_CHECKS: 'o-person-checks',
	PERSON_DESCENDING: 'o-person-descending',
	PERSON_SEARCH: 'o-person-search',
	PERSON_SETTINGS: 'o-person-settings',
	PERSON_SPEAK: 'o-person-speak',
	PERSON: 'o-person',
	PHONE_ADD: 'o-phone-add',
	PHONE_BROKEN: 'o-phone-broken',
	PHONE_DOWN: 'o-phone-down',
	PHONE_IN: 'o-phone-in',
	PHONE_OUT: 'o-phone-out',
	PHONE_UP: 'o-phone-up',
	PIN_LIST: 'o-pin-list',
	PIN: 'o-pin',
	PING: 'o-ping',
	PITCH_ZOOM: 'o-pitch-zoom',
	PLANNING: 'o-planning',
	POINT_LEFT: 'o-point-left',
	POINT_RIGHT: 'o-point-right',
	POWER: 'o-power',
	PRINTER: 'o-printer',
	PROCESSES: 'o-processes',
	PRODUCT: 'o-product',
	PROMPT_LIBRARY: 'o-prompt-library',
	PROMPT_VAR: 'o-prompt-var',
	PULSE: 'o-pulse',
	QR_CODE: 'o-qr-code',
	QUANTITY: 'o-quantity',
	QUESTION_L: 'o-question-l',
	QUESTION: 'o-question',
	QUOTE: 'o-quote',
	RECORD_VIDEO: 'o-record-video',
	REDO: 'o-redo',
	REFRESH: 'o-refresh',
	RELATED_TASKS: 'o-related-tasks',
	REMOVE_PERSON: 'o-remove-person',
	REPEAT_CYCLE: 'o-repeat-cycle',
	REPEAT_SALES: 'o-repeat-sales',
	REPEAT: 'o-repeat',
	RESUME: 'o-resume',
	ROBOT: 'o-robot',
	ROCKET: 'o-rocket',
	RUNNING_MAN: 'o-running-man',
	SAD: 'o-sad',
	SALE_TAG: 'o-sale-tag',
	SCREEN: 'o-screen',
	SCRUM: 'o-scrum',
	SEARCH: 'o-search',
	SEND: 'o-send',
	SENDED: 'o-sended',
	SERVICES: 'o-services',
	SET_COLUMNS: 'o-set-columns',
	SETTINGS: 'o-settings',
	SHARE_TASK: 'o-share-task',
	SHARE: 'o-share',
	SHIELD_ATTENTION: 'o-shield-attention',
	SHIELD_CHECKED: 'o-shield-checked',
	SHIELD: 'o-shield',
	SHOPPING_CART: 'o-shopping-cart',
	SHUFFLE: 'o-shuffle',
	SICK: 'o-sick',
	SIGMA_SUMM: 'o-sigma-summ',
	SIGN: 'o-sign',
	SMART_ACTIVITY: 'o-smart-activity',
	SMART_PROCESS: 'o-smart-process',
	SMILE: 'o-smile',
	SMS: 'o-sms',
	SORT_ACTIVITY: 'o-sort-activity',
	SORT_CALENDAR: 'o-sort-calendar',
	SOUND_OFF: 'o-sound-off',
	SOUND_ON: 'o-sound-on',
	SPEAKER: 'o-speaker',
	SPEED_0_5: 'o-speed-0_5',
	SPEED_0_7: 'o-speed-0_7',
	SPEED_1: 'o-speed-1',
	SPEED_1_2: 'o-speed-1_2',
	SPEED_1_5: 'o-speed-1_5',
	SPEED_1_7: 'o-speed-1_7',
	SPEED_2: 'o-speed-2',
	SPEED_METER: 'o-speed-meter',
	SPORT_MARATHON: 'o-sport-marathon',
	STAGE_MINUS: 'o-stage-minus',
	STAGE_PLUS: 'o-stage-plus',
	STAGE: 'o-stage',
	STAGES: 'o-stages',
	STOCK: 'o-stock',
	STOP_HAND_CROSSED: 'o-stop-hand-crossed',
	STOP_HAND: 'o-stop-hand',
	STORAGE: 'o-storage',
	STRESS: 'o-stress',
	STRIKETHROUGH: 'o-strikethrough',
	STRUCTURE_HORIZONTAL: 'o-structure-horizontal',
	STRUCTURE_VERTICAL: 'o-structure-vertical',
	SUBTASK: 'o-subtask',
	SUITCASE: 'o-suitcase',
	SUN: 'o-sun',
	SWITCH_CAMERA: 'o-switch-camera',
	SWITCHER: 'o-switcher',
	TABLET: 'o-tablet',
	TAG: 'o-tag',
	TARIFF_SCANER: 'o-tariff-scaner',
	TASK_LIST: 'o-task-list',
	TASK: 'o-task',
	TELEGRAM: 'o-telegram',
	TELEPHONY: 'o-telephony',
	TEXT: 'o-text',
	THEME: 'o-theme',
	THREAD_SINGLE: 'o-thread-single',
	THREAD: 'o-thread',
	TIMELINE: 'o-timeline',
	TIMER_DOT: 'o-timer-dot',
	TIMER: 'o-timer',
	TOPIC: 'o-topic',
	TRANSLATION: 'o-translation',
	TRASHCAN: 'o-trashcan',
	TREND_DOWN: 'o-trend-down',
	TREND_UP: 'o-trend-up',
	UNDERLINE: 'o-underline',
	UNDO: 'o-undo',
	UNLINK: 'o-unlink',
	UNPIN: 'o-unpin',
	UPLOAD_DOCUMENT: 'o-upload-document',
	UPLOAD_FILE: 'o-upload-file',
	UPLOAD: 'o-upload',
	USER_MASK: 'o-user-mask',
	VACATION: 'o-vacation',
	WALLET: 'o-wallet',
	WHATSAPP: 'o-whatsapp',
	WIFI: 'o-wifi',
	WINDOW_FLAG: 'o-window-flag',
	WINDOW_RING: 'o-window-ring',
	YANDEX_MAPS: 'o-yandex-maps',
	ZOOM_IN: 'o-zoom-in',
	ZOOM_OUT: 'o-zoom-out',
	ARROW_DOWN_L: 'arrow-down-l',
	ARROW_DOWN_M: 'arrow-down-m',
	ARROW_DOWN_S: 'arrow-down-s',
	ARROW_DOWN_XS: 'arrow-down-xs',
	ARROW_LEFT_L: 'arrow-left-l',
	ARROW_LEFT_M: 'arrow-left-m',
	ARROW_LEFT_S: 'arrow-left-s',
	ARROW_LEFT_XS: 'arrow-left-xs',
	ARROW_RIGHT_L: 'arrow-right-l',
	ARROW_RIGHT_M: 'arrow-right-m',
	ARROW_RIGHT_S: 'arrow-right-s',
	ARROW_RIGHT_XS: 'arrow-right-xs',
	ARROW_TOP_L: 'arrow-top-l',
	ARROW_TOP_M: 'arrow-top-m',
	ARROW_TOP_S: 'arrow-top-s',
	ARROW_TOP_XS: 'arrow-top-xs',
	BAN_L: 'ban-l',
	BAN_M: 'ban-m',
	BAN_S: 'ban-s',
	BAN_XS: 'ban-xs',
	CHECK_L: 'check-l',
	CHECK_M: 'check-m',
	CHECK_S: 'check-s',
	CHECK_XS: 'check-xs',
	CHEVRON_DOWN_L: 'chevron-down-l',
	CHEVRON_DOWN_M: 'chevron-down-m',
	CHEVRON_DOWN_S: 'chevron-down-s',
	CHEVRON_DOWN_XS: 'chevron-down-xs',
	CHEVRON_LEFT_L: 'chevron-left-l',
	CHEVRON_LEFT_M: 'chevron-left-m',
	CHEVRON_LEFT_S: 'chevron-left-s',
	CHEVRON_LEFT_XS: 'chevron-left-xs',
	CHEVRON_RIGHT_L: 'chevron-right-l',
	CHEVRON_RIGHT_M: 'chevron-right-m',
	CHEVRON_RIGHT_S: 'chevron-right-s',
	CHEVRON_RIGHT_XS: 'chevron-right-xs',
	CHEVRON_TOP_L: 'chevron-top-l',
	CHEVRON_TOP_M: 'chevron-top-m',
	CHEVRON_TOP_S: 'chevron-top-s',
	CHEVRON_TOP_XS: 'chevron-top-xs',
	COLLAPSE_L: 'collapse-l',
	COLLAPSE_M: 'collapse-m',
	COLLAPSE_S: 'collapse-s',
	COLLAPSE_XS: 'collapse-xs',
	CROSS_L: 'cross-l',
	CROSS_M: 'cross-m',
	CROSS_S: 'cross-s',
	CROSS_XS: 'cross-xs',
	DRAG_L: 'drag-l',
	DRAG_M: 'drag-m',
	DRAG_S: 'drag-s',
	DRAG_XS: 'drag-xs',
	EDIT_L: 'edit-l',
	EDIT_M: 'edit-m',
	EDIT_S: 'edit-s',
	EDIT_XS: 'edit-xs',
	EXCLAMATION_L: 'exclamation-l',
	EXCLAMATION_M: 'exclamation-m',
	EXCLAMATION_S: 'exclamation-s',
	EXCLAMATION_XS: 'exclamation-xs',
	EXPAND_L: 'expand-l',
	EXPAND_M: 'expand-m',
	EXPAND_S: 'expand-s',
	EXPAND_XS: 'expand-xs',
	FILTER_2_L: 'filter-2-l',
	FILTER_2_M: 'filter-2-m',
	FILTER_2_S: 'filter-2-s',
	FILTER_2_XS: 'filter-2-xs',
	GO_TO_L: 'go-to-l',
	GO_TO_M: 'go-to-m',
	GO_TO_S: 'go-to-s',
	GO_TO_XS: 'go-to-xs',
	LOCK_L: 'lock-l',
	LOCK_M: 'lock-m',
	LOCK_S: 'lock-s',
	LOCK_XS: 'lock-xs',
	LOCK_2: 'lock-2',
	MINUS_L: 'minus-l',
	MINUS_M: 'minus-m',
	MINUS_S: 'minus-s',
	MINUS_XS: 'minus-xs',
	MORE_L: 'more-l',
	MORE_M: 'more-m',
	MORE_S: 'more-s',
	MORE_XS: 'more-xs',
	PAUSE_L: 'pause-l',
	PAUSE_M: 'pause-m',
	PAUSE_S: 'pause-s',
	PAUSE_XS: 'pause-xs',
	PLAY_L: 'play-l',
	PLAY_M: 'play-m',
	PLAY_S: 'play-s',
	PLAY_XS: 'play-xs',
	PLUS_L: 'plus-l',
	PLUS_M: 'plus-m',
	PLUS_S: 'plus-s',
	PLUS_XS: 'plus-xs',
	STOP_L: 'stop-l',
	STOP_M: 'stop-m',
	STOP_S: 'stop-s',
	STOP_XS: 'stop-xs',
	UNLOCK_L: 'unlock-l',
	UNLOCK_M: 'unlock-m',
	UNLOCK_S: 'unlock-s',
	UNLOCK_XS: 'unlock-xs',
	SETTINGS_L: 'settings-l',
	SETTINGS_M: 'settings-m',
	SETTINGS_S: 'settings-s',
	SETTINGS_XS: 'settings-xs',
	AI_PROCESS: 'ai-process',
	AUTO_SELECTION: 'auto-selection',
	BUSINESS_PROCESS_MONEY: 'business-process-money',
	CALL_BACK: 'call-back',
	COLLAB_ADD: 'collab-add',
	CONTACT_DETAILS: 'contact-details',
	CONTRAST: 'contrast',
	CRM_FIELD_EXCEPT: 'crm-field-except',
	CRM_FIELD_LINKED: 'crm-field-linked',
	CRM_FIELD_SIMPLE: 'crm-field-simple',
	CUSTOMIZATION: 'customization',
	DDOS_ATTACK: 'ddos-attack',
	DELETE_EVENT: 'delete-event',
	DELIVERY_WITH_ITEM: 'delivery-with-item',
	DIGITS_24: 'digits-24',
	DOTS: 'dots',
	FEEDBACK_FORM: 'feedback-form',
	IP_ADDRESS: 'ip-address',
	IP_ADDRESS_CROSSED: 'ip-address-crossed',
	LETTER_SORT_DOWN: 'letter-sort-down',
	LETTER_SORT_UP: 'letter-sort-up',
	LIST_AI: 'list-ai',
	LOGO_ANDROID: 'logo-android',
	LOGO_APPLE: 'logo-apple',
	MULTI_PAGE_FORM: 'multi-page-form',
	NO_SCREENSHOT: 'no-screenshot',
	ONLINE_EVENTS: 'online-events',
	PAYMENT_AND_DELIVERY: 'o-payment-and-delivery',
	PERSONAL_FORM: 'personal-form',
	PRIVATE_MESSAGE: 'private-message',
	PROCESS: 'process',
	PROCESS_STOP: 'process-stop',
	PRODUCTS_CUBE: 'products-cube',
	PRODUCTS_PAYMENT: 'products-payment',
	PRODUCTS_PHOTO: 'products-photo',
	PRODUCTS_SHIRT: 'products-shirt',
	PRODUCTS_QUICK_CRM_FILL: 'products-quick-crm-fill',
	RECEIPT: 'receipt',
	RECEIPT_NOTE: 'receipt-note',
	RECORD_ON: 'record-on',
	REGISTRATION_ON_SITE: 'registration-on-site',
	SCREEN_PHONE: 'screen-phone',
	SERVER_SETTINGS: 'server-settings',
	SPEAKER_ADD: 'speaker-add',
	TEMPLATE_TASK: 'template-task',
	TEXT_FORMAT_BOTTOM: 'text-format-bottom',
	TEXT_FORMAT_CANCEL: 'text-format-cancel',
	TEXT_FORMAT_TOP: 'text-format-top',
	TEXT_FORMAT_TOP_LEFT: 'text-format-top-left',
	TEXT_FORMAT_TOP_RIGHT: 'text-format-top-right',
	TRAINEE: 'trainee',
	USER_PROFILE: 'user-profile',
	VERIFICATION: 'verification',
	VIRTUAL_SERVER: 'virtual-server',
	VIRTUAL_STORAGE: 'virtual-storage',
	VK_LEAD_FORM: 'vk-lead-form',
	WATERMARK: 'watermark',
	WIKI: 'wiki',
	POLL: 'poll',
	ACTION_REQUIRED: 'action-required',
	AI_INTERNET_SEARCH: 'ai-internet-search',
	AI_REFLECTION: 'ai-reflection',
	CONTACT_CENTER: 'contact-center',
	DELETE_PERSON: 'delete-person',
	DIGITS_123: 'digits123',
	LOCATION_PLUS: 'o-location-plus',
	TRANSCRIPTION: 'transcription',
	AUTO_CHECK_IN: 'auto-check-in',
	BROOM: 'broom',
	CHECK_DEFERRED: 'check-deferred',
	CHECK_IN_CANCEL: 'check-in-cancel',
	CHECK_IN_NEGATIVE: 'check-in-negative',
	COMPASS: 'compass',
	FACE_IDENT: 'face-ident',
	FINGERPRINT: 'fingerprint',
	GRAPHS_SETTINGS: 'graphs-settings',
	KEYBOARD: 'o-keyboard',
	MEDIA_MESSAGE: 'media-message',
	MOBILE_SELECTED: 'mobile-selected',
	NO_COMPASS: 'no-compass',
	PERSON_DETECT: 'person-detect',
	REPLY_ALL: 'reply-all',
	SCREEN_SELECTED: 'screen-selected',
	SCREEN_SHARE_PAUSE: 'screen-share-pause',
	SIGN_DEFAULT: 'sign-default',
	SIZE_W_L: 'size-w-l',
	STATISTICS_ARROW: 'statistics-arrow',
	STICKER: 'sticker',
	BROWSER: 'browser',
	MORE_VERTICAL_XS: 'more-vertical-xs',
	MORE_VERTICAL_S: 'more-vertical-s',
	MORE_VERTICAL_M: 'more-vertical-m',
	MORE_VERTICAL_L: 'more-vertical-l',
	DATABASE: 'o-database',
	CLIENT_CHAT: 'o-client-chat',
	LEGAL_PROCESSES: 'o-legal-processes',
	MARKETING: 'o-marketing',
	ROLES_LIBRARY: 'o-roles-library',
	AI_ROBOT: 'o-ai-robot',
	CONDITION: 'o-condition',
	DATA_READING: 'o-data-reading',
	FRAME_CREATE: 'o-frame-create',
	MCP: 'o-mcp',
	MCP_LETTERS: 'o-mcp-letters',
	MERGE: 'o-merge',
	STICKER_SMILE: 'o-sticker-smile',
	CLIENT_LETTER: 'o-client-letter',
	CONNECTION: 'o-connection',
	COPIED: 'o-copied',
	CRM_ONLINE_STORE: 'o-crm-online-store',
	CRM_PAYMENT_AND_DELIVERY: 'o-crm-payment-and-delivery',
	LIGHTNING_PLUS: 'o-lightning-plus',
	UNC_1: 'o-unc-1',
	DOCUMENT_SIGN: 'o-document-sign',
	BLACK_LIST: 'o-black-list',
	IMPORTANT_TASK: 'o-important-task',
	ADD_DATABASE: 'o-add-database',
	BANK_CARD: 'o-bank-card',
	CIRCLECHECK_FORWARD: 'o-circlecheck-forward',
	CROWN_1: 'o-crown-1',
	DIAL_10: 'o-dial-10',
	DIAL_20: 'o-dial-20',
	DOCUMENT_LINK: 'o-document-link',
	DOCUMENT_PRINT: 'o-document-print',
	LIST_AI_2: 'o-list-ai-2',
	PARTS_RECORD: 'o-parts-record',
	PARTS_RECORD_PLAY: 'o-parts-record-play',
	PARTS_RECORD_STOP: 'o-parts-record-stop',
	PLANNING_2: 'o-planning-2',
	SEEN_ITEMS: 'o-seen-items',
	SHOP_ORDER: 'o-shop-order',
	SSO: 'o-sso',
	TABLE: 'o-table',
	TASK_FIRE: 'o-task-fire',
	UNIVERSAL_ACCESS: 'o-universal-access',
	VISITED_ITEMS: 'o-visited-items',
	WEBHOOK: 'o-webhook',
	TEXT_FORMAT_RESET: 'o-text-format-reset',
	SPOILER: 'o-spoiler',
	OPEN_NEW: 'o-open-new',
	LIST_VIEWER: 'o-list-viewer',
	VIDEO_RECORD_2: 'o-video-record-2',
	THREE_PERSONS_CHECK: 'o-three-persons-check',
	PACKAGE_RECEIVE: 'o-package-receive',
	PACKAGE_CANCEL: 'o-package-cancel',
	LOWER_LEFT_ARROW: 'o-lower-left-arrow',
	MAIL_PLUS: 'o-mail-plus',
	MESSAGES_MULTI: 'o-messages-multi',
	CRM_FORM: 'o-crm-form',
	BITRIX_GPT: 'bitrix-gpt',
	RECENT_ITEMS: 'o-recent-items',
	SET_KANBAN: 'o-set-kanban',
	TEMPLATE_PLUS: 'o-template-plus',
	O_TEMPLATE_TASK: 'o-template-task',
	COOKIES: 'o-cookies',
	PAGES: 'o-pages',
	VIBECODE_CATALOG: 'o-vibecode-catalog',
	COMMANDS: 'o-commands',
	FILE_WITH_CALENDAR: 'o-file-with-calendar',
	FILE_WITH_CROWN: 'o-file-with-crown',
	FILE_WITH_PERSON: 'o-file-with-person',
} as const);
